import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { BookACallFooterComponent } from '@app/+onboarding/components/book-a-call-footer/book-a-call-footer.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';
import { CardComponent } from '@sb/ui/card';
import { ChecklistContentComponent, ChecklistItemModel, ChecklistProgressHeadingComponent } from '@sb/ui/checklist';
import { ProgressBarModel } from '@sb/ui/progress-bar';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'my-checklist-widget',
  imports: [
    ChecklistContentComponent,
    ChecklistProgressHeadingComponent,
    CardComponent,
    TranslatePipe,
    ButtonComponent,
    BookACallFooterComponent,
  ],
  templateUrl: './my-checklist-widget.component.html',
})
export class MyChecklistWidgetComponent {
  items = input<ChecklistItemModel[]>();
  title = input<string>();
  progress = input<ProgressBarModel>();
  showFooter = input(false);
  dismissed = output<void>();

  handleClick() {
    this.dismissed.emit();
  }
}
